export default __webpack_public_path__ + "static/product-wet-towels-a67ec93f9de227de1cf708983bff230f.png";